var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhyVisitorsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 69 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "why-visitors-icon_svg__a",
    d: "M0 0h68.852v68.852H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "why-visitors-icon_svg__c",
    d: "M0 70h68.852V0H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "why-visitors-icon_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#why-visitors-icon_svg__a"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.852 34.426c0 19.013-15.413 34.426-34.426 34.426S0 53.44 0 34.426 15.413 0 34.426 0s34.426 15.413 34.426 34.426",
    fill: "#F8D7CC",
    mask: "url(#why-visitors-icon_svg__b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.934 28.688H14.918c-4.298 0-12.623 2.25-12.623 6.792v13.864c0 2.674 1.916 4.637 4.59 4.637l1.148-.047V70H60.82V53.934l1.147.047c2.674 0 4.59-1.963 4.59-4.637V35.48c0-4.541-8.325-6.792-12.623-6.792",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.426 24.098c-4.297 0-12.623 2.345-12.623 6.885v13.865c0 2.674 1.917 4.496 4.59 4.496h1.148V70h13.77V49.344h1.148c2.674 0 4.59-1.822 4.59-4.496V30.983c0-4.54-8.325-6.885-12.623-6.885",
    fill: "#E74A10"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.459 50.586V48.29c2.027 0 3.442-1.415 3.442-3.443V30.984c0-3.504-7.534-5.738-11.475-5.738-3.94 0-11.475 2.234-11.475 5.738v13.864c0 2.028 1.415 3.443 3.442 3.443v2.295c-3.324 0-5.737-2.413-5.737-5.738V30.984c0-5.35 8.828-8.033 13.77-8.033s13.77 2.684 13.77 8.033v13.864c0 3.325-2.413 5.738-5.737 5.738",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.426 20.641c3.204 0 5.738-2.62 5.738-5.855v-1.952c0-3.233-2.534-5.856-5.738-5.856-3.204 0-5.737 2.623-5.737 5.856v1.952c0 3.234 2.533 5.855 5.737 5.855",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.426 8.127c-2.531 0-4.59 2.111-4.59 4.707v1.952c0 2.64 2.016 4.707 4.59 4.707s4.59-2.066 4.59-4.707v-1.952c0-2.64-2.016-4.707-4.59-4.707m0 13.661c-3.797 0-6.885-3.14-6.885-7.002v-1.952c0-3.861 3.088-7.002 6.885-7.002 3.797 0 6.885 3.14 6.885 7.002v1.952c0 3.862-3.088 7.002-6.885 7.002M61.967 55.129v-2.295c2.028 0 3.443-1.436 3.443-3.49V35.48c0-3.501-7.43-5.644-11.476-5.644h-4.59v-2.295h4.59c4.652 0 13.77 2.397 13.77 7.939v13.864c0 3.298-2.465 5.785-5.737 5.785",
    fill: "#020303"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "why-visitors-icon_svg__d",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#why-visitors-icon_svg__c"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#why-visitors-icon_svg__d)",
    d: "M59.672 70h2.295V40.164h-2.295z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.934 25.137c3.204 0 5.738-2.62 5.738-5.854V17.33c0-3.233-2.534-5.855-5.738-5.855-3.204 0-5.737 2.622-5.737 5.855v1.953c0 3.233 2.533 5.854 5.737 5.854",
    fill: "#FEFEFE",
    mask: "url(#why-visitors-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.934 12.623c-2.531 0-4.59 2.111-4.59 4.707v1.953c0 2.595 2.059 4.706 4.59 4.706 2.574 0 4.59-2.066 4.59-4.706V17.33c0-2.64-2.016-4.707-4.59-4.707m0 13.661c-3.797 0-6.885-3.14-6.885-7V17.33c0-3.861 3.088-7.002 6.885-7.002 3.797 0 6.885 3.14 6.885 7.002v1.953c0 3.86-3.088 7.001-6.885 7.001M6.885 55.129c-3.272 0-5.738-2.487-5.738-5.785V35.48c0-5.542 9.119-7.939 13.77-7.939h4.591v2.295h-4.59c-4.045 0-11.476 2.143-11.476 5.644v13.864c0 2.054 1.415 3.49 3.443 3.49v2.295z",
    fill: "#020303",
    mask: "url(#why-visitors-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#020303",
    mask: "url(#why-visitors-icon_svg__d)",
    d: "M6.885 70H9.18V40.164H6.885z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918 25.137c-3.204 0-5.738-2.62-5.738-5.854V17.33c0-3.233 2.534-5.855 5.738-5.855 3.204 0 5.738 2.622 5.738 5.855v1.953c0 3.233-2.534 5.854-5.738 5.854",
    fill: "#FEFEFE",
    mask: "url(#why-visitors-icon_svg__d)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.918 12.623c-2.532 0-4.59 2.111-4.59 4.707v1.953c0 2.595 2.058 4.706 4.59 4.706 2.574 0 4.59-2.066 4.59-4.706V17.33c0-2.64-2.016-4.707-4.59-4.707m0 13.661c-3.797 0-6.885-3.14-6.885-7V17.33c0-3.861 3.088-7.002 6.885-7.002 3.797 0 6.885 3.14 6.885 7.002v1.953c0 3.86-3.088 7.001-6.885 7.001M40.164 70h2.295V35.574h-2.295zM26.393 70h2.296V35.574h-2.296zM33.279 70h2.295V48.197h-2.295z",
    fill: "#020303",
    mask: "url(#why-visitors-icon_svg__d)"
  }))));
}
export default SvgWhyVisitorsIcon;